import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import smallarrow from 'src/assets/images/SmallDownArrow.svg';
import clsx from 'clsx';

import {
    StyledCategoryContainer,
    StyledCategoryName,
    ImageContainer,
    StyledContainer,
} from './Category.styled';
import { useTranslation } from 'react-i18next';
import { logErrorToConsole } from 'src/utils/util';
const useStyles = makeStyles((theme) => ({
    root: {
        width: 500,
    },
    typography: {
        width: '12rem',
        padding: theme.spacing(1),
        borderBottom: '1px solid rgba(112,112,112, 0.12)',
        textAlign: 'left',
        fontFamily: 'AvenirNextWorld Regular',
        letterSpacing: '0px',
        color: '#222222',
        opacity: '1',
        fontSize: '14px',
        cursor: 'pointer',
    },
    selected: {
        fontFamily: 'AvenirNextWorld Demi',
    },
}));

const Category = ({
    categoryList,
    categoryOpen,
    categoryAnchorEl,
    categoryName,
    categoryChange,
    categoryOpenHandler,
    clickAwayHandler,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <>
            <StyledCategoryContainer>
                <StyledContainer
                id="orders-category-dropdown-trigger"
                    onClick={(e) => {
                        categoryOpenHandler(e);
                    }}
                >
                    <StyledCategoryName>
                        {categoryName ===
                        t('orders.orderQuickFilters.deniedUsageOverrides.name')
                            ? t('orders.index.mydenied')
                            : categoryName}
                    </StyledCategoryName>
                    <ImageContainer
                        cursor={'pointer'}
                        src={smallarrow}
                        alt="down-arrow"
                        isExpanded={categoryOpen}
                        width="auto"
                        height="auto"
                    />
                </StyledContainer>
            </StyledCategoryContainer>

            <Popper
                open={categoryOpen}
                anchorEl={categoryAnchorEl}
                placement={'bottom-start'}
                transition
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener id="orders-category-dropdown-clickaway-listener" onClickAway={clickAwayHandler}>
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper>
                                {categoryList.map((catList) => {
                                    return (
                                        <Typography
                                        id={`orders-category-dropdown-option-${catList.id}`}
                                            key={catList.id}
                                            onClick={() => {
                                                try {
                                                categoryChange(catList.id);
                                                 } catch (error) {
                                                    logErrorToConsole(error);
                                                 }
                                            }}
                                            className={
                                                catList.categoryName ===
                                                categoryName
                                                    ? clsx(
                                                          classes.typography,
                                                          classes.selected
                                                      )
                                                    : classes.typography
                                            }
                                        >
                                            {catList.categoryName}
                                        </Typography>
                                    );
                                })}
                            </Paper>
                        </Fade>
                    </ClickAwayListener>
                )}
            </Popper>
        </>
    );
};

export default Category;
